import { Component, signal, OnInit, Renderer2, Inject } from '@angular/core';
import { NavigationEnd, RouterOutlet } from '@angular/router';
import { CommonModule , DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AuthService } from './services/auth.service';
import { filter, Observable } from 'rxjs';
import { FooterComponent } from './components/footer/footer.component';
import { CommonService } from './services/common-service';
import { environment } from '../environments/environment';
import { DashboardHeader } from "./components/dashboards/common/dashboard-header/dashboard-header";
import { InactivityService } from './services/inactivity.service'; // Add this import
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CommonModule, FooterComponent, DashboardHeader],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  standalone: true
})
export class App implements OnInit {
  userRole = '';
  showDashboardHeader: boolean = false;
  constructor(
    private msalService: MsalService,
    private authService: AuthService,
    private router: Router,
    public commonService: CommonService,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    private inactivityService: InactivityService
  ) {
    console.log('API Base URL:', environment.apiBaseUrl);
    const activeAccount = this.msalService.instance.getActiveAccount();
    this.authService.setIsLoggedIn(!!activeAccount);
    this.loadCookieConsent();
  }
  ngOnInit() {
    this.inactivityService.startMonitoring();
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      // Set the flag based on the URL
      this.showDashboardHeader = event.urlAfterRedirects.search('dashboards') > -1;
      if(this.showDashboardHeader)
      {
        if (document.body.firstElementChild) {
          document.body.firstElementChild.className = '';
        }
      }else{
        if (document.body.firstElementChild) {
          document.body.firstElementChild.className = 'zoom';
        }
      }
    });

    // handleRedirectPromise was already called in main.ts before bootstrap.
    // Post-login redirect is handled automatically by MSAL via
    // navigateToLoginRequestUrl: true + redirectStartPage in AuthGuard.
    const activeAccount = this.msalService.instance.getActiveAccount();
    if (activeAccount) {
      this.authService.setIsLoggedIn(true);
    }
  }

  login() {
    this.authService.login();
  }

  logout() {
    this.authService.logout();
  }

  get isLoggedIn(): Observable<boolean> {
    return this.authService.getIsLoggedIn();
  }

  loadCookieConsent() {
    const prodEnv = [
      'https://advisoryqrm-monitoring.deloitte.com'
    ];
    const hostName = window.location.hostname;
    const isProdEnv = prodEnv.some(env => env === hostName.toLowerCase());

    const script = this._renderer2.createElement('script');
    let dataDomainScript;

    if (isProdEnv) {
      dataDomainScript = "019eedc8-9c3b-7284-b3ce-376360a228bd";
    } else {
      dataDomainScript = "019eedc8-9c3b-7284-b3ce-376360a228bd-test";
    }

    script.src = `https://cdn.cookielaw.org/scripttemplates/otSDKStub.js`;
    script.type = `text/javascript`;
    script.charset = `UTF-8`;
    script.setAttribute("data-domain-script", dataDomainScript);
    this._renderer2.appendChild(this._document.body, script);

    const optanonScript = this._renderer2.createElement('script');
    optanonScript.type = `text/javascript`;
    optanonScript.innerHTML = `function OptanonWrapper() { }`;

    this._renderer2.appendChild(this._document.body, optanonScript);
  }
}
